import * as React from 'react';

import { IconProps } from '../Icon';

export const DashboardFilledIcon = ({
  width,
  color,
}: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_COLOR = 'none';

  return (
    <svg
      aria-hidden="true"
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 512 512"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g data-name="Layer 2" id="Layer_2">
        <g id="dashboard">
          <rect height="234.43" rx="41.38" width="234.43" x="277.57" />
          <rect height="234.43" rx="41.38" width="234.43" />
          <rect
            height="234.43"
            rx="41.38"
            width="234.43"
            x="277.57"
            y="277.57"
          />
          <rect height="234.43" rx="41.38" width="234.43" y="277.57" />
        </g>
      </g>
    </svg>
  );
};
